(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lazy-line-painter", [], factory);
	else if(typeof exports === 'object')
		exports["lazy-line-painter"] = factory();
	else
		root["lazy-line-painter"] = factory();
})(self, () => {
return 